import { TAGS, api } from "@/store/api.ts"
import { ICard, IDeckHandResponse } from "."

const basePath = "/deck"

export const deckApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.DECK]
})

export const deckEndpoints = deckApi.injectEndpoints({
  endpoints: (builder) => ({
    getDeckHand: builder.query<IDeckHandResponse, string>({
      query: (sessionId: string) => ({
        url: `${basePath}/hand/${sessionId}`,
        method: "GET"
      }),
      providesTags: (_, __, sessionId) => [
        { type: TAGS.DECK, id: `HAND` },
        { type: TAGS.DECK, id: `HAND:${sessionId}` }
      ]
    }),
    getDeckLastCard: builder.mutation<ICard, string>({
      query: (sessionId: string) => ({
        url: `${basePath}/last-card/${sessionId}`,
        method: "GET"
      })
    })
  })
})

export const {
  useGetDeckHandQuery,
  useGetDeckLastCardMutation,
  endpoints: { getDeckHand }
} = deckEndpoints
